module.exports = __webpack_public_path__ + "assets/images/MicrophonePointerRight.7470e527e7ddd8298c8f6352cf56011d.svg";